import { httpGet, httpPost, httpDelete } from "@/request/http";
import func from "@/funcs";

let path = "/nationalitys";

export default {
  getPages(dTO) {
    return httpGet(`${path}/pages`, dTO);
  },
  get(id) {
    return httpGet(`${path}/${id}`);
  },
  save(item) {
    return httpPost(path, item);
  },
  remove(id) {
    return httpDelete(`${path}/${id}`);
  },
  getExcel() {
    func.getExcel.get(`${path}/excel`, "國籍");
  },
  postExcel(formData) {
    return func.postExcel(`${path}/excel`, formData);
  },
};
